import React from 'react';

import { getImageExt, IMAGE_EXTS } from '@utils/Util';

export const SelectedFileViewComponent = ({ file, showRemoveOption, index, remove }) => {
	const ext = getImageExt(file.name);

	const renderCrossIcon = () => (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="8" fill="#8B8B8B"></circle>
			<path
				d="M11.5 5.205L10.795 4.5L8 7.295L5.205 4.5L4.5 5.205L7.295 8L4.5 10.795L5.205 11.5L8 8.705L10.795 11.5L11.5 10.795L8.705 8L11.5 5.205Z"
				fill="white"
			></path>
		</svg>
	);

	const renderFiles = () => {
		return (
			<div className="item">
				{showRemoveOption && (
					<div className="close" onClick={(event) => remove(index, event)}>
						{renderCrossIcon()}
					</div>
				)}

				<a href={file.docUrl} target="_blank" rel="noreferrer">
					{IMAGE_EXTS.includes(ext) ? (
						<img src={showRemoveOption ? file.base64Str : file.docUrl} alt="" />
					) : (
						<span>{ext}</span>
					)}
				</a>
			</div>
		);
	};

	return <div className="item file-item">{renderFiles()}</div>;
};
